import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    filterBar: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 10,
    },
    filterLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    filterLabel: {
        marginRight: 5,
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
    },
    alertWrapper: {
        padding: '1%',
        textAlign: 'center',
    },
    gridWrapper: {
        overflowX: 'auto',
        maxHeight: '75vh'
    },
    drillButton: {
        float: 'right',
    },
    infoIcon: {
        marginLeft: 4,
        color: '#aaa',
        cursor: 'default',
    },
    footnotes: {
        marginTop: 8,
        paddingLeft: 4,
    },
    footnote: {
        fontSize: 12,
        color: '#666',
        marginBottom: 2,
    },
    headerCell: {
        textAlign: 'center',
        backgroundColor: 'rgb(221, 221, 221)',
        border: '1px solid white',
    },
    headerCellActive: {
        textAlign: 'center',
        backgroundColor: 'rgb(190, 190, 190)',
        border: '1px solid white',
    },
    labelCell: {
        textAlign: 'left',
        paddingLeft: 10,
    },
    dataCell: {
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    compactCell: {
        padding: '2px 6px',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    compactHeaderCell: {
        padding: '2px 6px',
        textAlign: 'center',
        backgroundColor: 'rgb(221, 221, 221)',
        border: '1px solid white',
    },
    centerListHeader: {
        position: 'sticky',
        top: '0px'
    },
};
